import PropTypes from 'prop-types';
import { AlertCircle } from 'lucide-react';

// Component to display a list of validation errors in a styled box
const ValidationError = ({ errors }) => {
  if (!errors || errors.length === 0) {
    return null; // Don't render if there are no errors
  }

  return (
    <div className="p-4 bg-huntd-error/10 border border-huntd-error/20 rounded-lg">
      <div className="flex items-center mb-2">
        <AlertCircle className="w-5 h-5 text-huntd-error mr-2 flex-shrink-0" />
        <h3 className="text-base font-medium text-huntd-error">
          Validation Errors Found
        </h3>
      </div>
      <ul className="list-disc list-inside text-base text-huntd-error/80 ml-7"> {/* Indent list below icon */}
        {errors.map((error, index) => (
          <li key={index}>{error}</li>
        ))}
      </ul>
    </div>
  );
};

ValidationError.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default ValidationError;